/* eslint-disable no-multi-assign */
/* eslint-disable no-param-reassign */
import React from 'react';
import classNames from 'classnames';

import { useUrlGenerator } from '../../contexts/RoutesContext';

import Link from './Link';

import logo from '../../../img/logo.svg';

import styles from '../../../styles/partials/trees.module.scss';

const propTypes = {};

const defaultProps = {};

const TreesPartial = () => {
    const url = useUrlGenerator();
    // const { width, height } = useWindowSize();

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.ready]: true,
                    [styles.logoResized]: true,
                    [styles.staticBackground]: true,
                },
            ])}
        >
            <Link to={url('home')}>
                <img className={styles.logo} src={logo} alt="Logo" />
            </Link>
            <div className={styles.texture} />
        </div>
    );
};

TreesPartial.propTypes = propTypes;
TreesPartial.defaultProps = defaultProps;

export default TreesPartial;
